/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".row-propiedades[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap}.row-propiedades[_ngcontent-%COMP%] > [class*=col-][_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:15px}\n/*# sourceMappingURL=propiedades-rurales.component.css.map*/"];
export { styles as styles };
